import { IAddUser } from "../RoleManagement.types";
import { EMAIL_REGEX } from "./constants";

export const isAddUserFormValid = (form: IAddUser): boolean => {
  const { firstname, lastname, email } = form;
  return (
    !!firstname &&
    firstname.length > 0 &&
    !!lastname &&
    lastname.length > 0 &&
    !!email &&
    email.length > 0 &&
    EMAIL_REGEX.test(email)
  );
};
